import { useEffect, useState } from "react";
import useAlert from "../Alerts/useAlert";
import { BusinessUnit } from "../Types/BusinessUnit";
import { Line } from "../Types/Line";
import { typeCheckResponse } from "./TypeUtils";
import { useHttpUtils } from "./useHttpUtils";

export const useLines = (initialBusinessUnits: BusinessUnit[]) => {
    const { fetchDataAuthenticated } = useHttpUtils();
    const { setAlert } = useAlert();
    const [lines, setLines] = useState<Line[]>([]);
    const [loading, setLoading] = useState(true);
    const [businessUnits, setBusinessUnits] = useState(initialBusinessUnits ?? []);

    useEffect(() => {
        // Check if business units and initial business units are equivalent, if they are skip
        if (initialBusinessUnits.every(bu => businessUnits.some(b => b.code === bu.code))
            && businessUnits.every(bu => initialBusinessUnits.some(b => b.code === bu.code))) {
            return;
        }
        setBusinessUnits(initialBusinessUnits);
    }, [businessUnits, initialBusinessUnits])

    useEffect(() => {
        setLoading(true);
        let businessUnitIds = businessUnits
            .filter(bu => bu.businessUnitId !== undefined)
            .map(bu => bu.businessUnitId!);

        fetchDataAuthenticated(`api/v1/line/multiplebusinessunit?businessUnitIds=${businessUnitIds.join(", ")}`)
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error("Failed to get lines");
            })
            .then(data => {
                const expectedType: Line[] = [];
                if (!typeCheckResponse(data, expectedType)) {
                    throw new Error("Data was not expected type when fetching business units");
                }
                setLines(data);
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [businessUnits, fetchDataAuthenticated, setAlert]);

    return {loading, lines};
};